import { CategoryInterface } from "../../../interfaces/categoryInterface";
import { ProductInterface } from "../../../interfaces/productInterface";

type ItemMap = {
  product: ProductInterface;
  category: CategoryInterface;
};

export const findItem = <K extends keyof ItemMap>(
  type: K,
  items: Array<ItemMap[K]>,
  id: string,
): ItemMap[K] | undefined => {
  return items.find((item) => item?._id === id);
};
